<template>
  <svg
    width="4"
    height="12"
    viewBox="0 0 4 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.58333 2.3335C1.81345 2.3335 2 2.14695 2 1.91683C2 1.68671 1.81345 1.50016
      1.58333 1.50016C1.35322 1.50016 1.16667 1.68671 1.16667 1.91683C1.16667 2.14695
      1.35322 2.3335 1.58333 2.3335ZM0 1.91683C0 1.04238 0.708883 0.333496 1.58333
      0.333496C2.45778 0.333496 3.16667 1.04238 3.16667 1.91683C3.16667 2.79128
      2.45778 3.50016 1.58333 3.50016C0.708883 3.50016 0 2.79128 0 1.91683ZM1.58333
      6.41683C1.81345 6.41683 2 6.23028 2 6.00016C2 5.77004 1.81345 5.5835 1.58333
      5.5835C1.35321 5.5835 1.16667 5.77004 1.16667 6.00016C1.16667 6.23028 1.35321
      6.41683 1.58333 6.41683ZM0 6.00016C0 5.12571 0.708883 4.41683 1.58333
      4.41683C2.45778 4.41683 3.16667 5.12571 3.16667 6.00016C3.16667 6.87461 2.45778
      7.5835 1.58333 7.5835C0.708883 7.5835 0 6.87461 0 6.00016ZM2 10.0835C2 10.3136
      1.81345 10.5002 1.58333 10.5002C1.35321 10.5002 1.16667 10.3136 1.16667
      10.0835C1.16667 9.85338 1.35321 9.66683 1.58333 9.66683C1.81345 9.66683
      2 9.85338 2 10.0835ZM1.58333 8.50016C0.708883 8.50016 0 9.20905 0 10.0835C0
      10.9579 0.708883 11.6668 1.58333 11.6668C2.45778 11.6668 3.16667 10.9579
      3.16667 10.0835C3.16667 9.20905 2.45778 8.50016 1.58333 8.50016Z"
      fill="currentColor"
    />
  </svg>
</template>